export default __webpack_public_path__ + "static/char-s-sp02-jp-18df79d31e23de188d1045ffa8075091.webp";